import {Component, Mixins, Prop} from "vue-property-decorator";
import CrudMixin from "@/mixins/CrudMixin";
import MaskedInput from "vue-text-mask";
import flatPickr from "vue-flatpickr-component";
import {ProviderEcfmg} from "@/components/provider/cards/education/ProviderEcfmg";
import DataLoadCard from "@/componentsReusable/DataLoadCard.vue";
import RowItemSummary from "@/componentsReusable/RowItemSummary.vue";
import CrudList from "@/componentsReusable/CrudList.vue";
import {InputType} from "@/componentsReusable/InputType";
import InputAndError from "@/componentsReusable/InputAndError.vue";
import {UserRoleEnum} from "@/enums/userRolesEnum";

@Component({
  components: {
    DataLoadCard,
    CrudList,
    RowItemSummary,
    CrudMixin,
    MaskedInput,
    flatPickr,
    InputAndError
  }
})
export default class ProviderEcfmgItem extends Mixins(CrudMixin) {

  @Prop({type: [String, Number], required: true})
  protected providerId!: number;

  get isProviderUser (): boolean {
    return this.$store.getters['user/hasOnlyRole'](UserRoleEnum.PROVIDER);
  }

  protected InputType = InputType;

  protected getNewBlankItemWithDefaultValues(): ProviderEcfmg {
    return {
      id: 0,
      providerId: this.providerId,
      certificateNumber: '',
      issuedOn: null,
      isNew: true,
      isEditing: true,
      isUpdating: false
    };
  }

  protected getFetchUrl(): string {
    return `/api/providers/${this.providerId}/ecfmg`;
  }

  protected getWriteUrl(): string {
    return `/api/providers/${this.providerId}/ecfmg`;
  }

  protected getFieldNames(): string[] {
    return [
      "id",
      "providerId",
      "certificateNumber",
      "issuedOn"
    ]
  }

  protected getStringDateFields(): string[] {
    return [
      "issuedOn"
    ];
  }

}



// WEBPACK FOOTER //
// ./src/components/provider/cards/education/ProviderEcfmgItem.ts